import { defineTextStyles } from '@chakra-ui/react';

export const textStyles = defineTextStyles({
  '2xs': {
    value: {
      fontSize: '2xs',
      lineHeight: '0.75rem',
    },
  },
  xs: {
    value: {
      fontSize: 'xs',
      lineHeight: '1.5em',
    },
  },
  sm: {
    value: {
      fontSize: 'sm',
      lineHeight: '1.5em',
    },
  },
  md: {
    value: {
      fontSize: 'md',
      lineHeight: '1.5em',
    },
  },
  lg: {
    value: {
      fontSize: 'lg',
      lineHeight: '1.5em',
    },
  },
  xl: {
    value: {
      fontSize: 'xl',
      lineHeight: '1.5em',
    },
  },
  '2xl': {
    value: {
      fontSize: '2xl',
      lineHeight: '1.5em',
    },
  },
  '3xl': {
    value: {
      fontSize: '3xl',
      lineHeight: '1.5em',
    },
  },
  '4xl': {
    value: {
      fontSize: '4xl',
      lineHeight: '1.5em',
    },
  },
  '5xl': {
    value: {
      fontSize: '5xl',
      lineHeight: '1.5em',
    },
  },
  '6xl': {
    value: {
      fontSize: '6xl',
      lineHeight: '1.5em',
    },
  },
  '7xl': {
    value: {
      fontSize: '7xl',
      lineHeight: '1.5em',
    },
  },
  none: {
    value: {},
  },
});
